import { Badge, BadgeProps } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

type BooleanBadgeProps = Omit<BadgeProps, "variant" | "chilren"> & {
  value: boolean;
};

export const BooleanBadge = ({ value, ...props }: BooleanBadgeProps) => {
  const { t } = useTranslation();

  return (
    <Badge {...props} variant={value ? "published" : "outlinedWarning"}>
      {t(String(value))}
    </Badge>
  );
};
